import BigDialog from 'components/BigDialog';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions as actionsRawMaterials } from 'ducks/rawMaterials';
import { actions as actionsRawMatSuppliers } from 'ducks/rawMaterialSuppliers';
import { actions as actionsSupplierRegister } from 'ducks/supplierRegister';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
  directRegistersByShipment, lookUpIdValueSelector, shipmentsByRawMaterial
} from 'selectors/generic';
import columns from 'utils/tables/columns/product/productShipment';
import { validator as productShipmentValidator } from 'utils/tables/validators/productShipment';
import rawMaterialValidator from 'utils/tables/validators/rawMaterial';
import { validator as shipmentRegisterValidator } from 'utils/tables/validators/shipmentRegistersMixtures';
import { currentAccount, currentUser } from 'selectors/currentUser';

const Component = props => {
  const {
    directRegisters, idAccount, rawMaterial, rawMaterialsData, shipmentsOf,
    suppliers, user, userAccount
  } = props;
  const {
    alertError, closeParentContainer, shipmentType, createRawMatSupplier, createSupplierRegister,
    fetchRawMaterial, postInsertRequest, removeRawMatSupplier,
    removeSupplierRegister, updateRawMatSupplier, updateRawMaterial, updateSupplierRegister
  } = props;
  let shipments = shipmentsOf[rawMaterial.id] || [];

  const [shipmentIdSelected, setShipmentIdSelected] = useState(undefined);
  const tableRef = useRef();

  shipments = shipments
    .filter(shipment => shipment.reach_role === shipmentType)
    .map(shipment => {
    const shipmentRegisters = directRegisters[shipment.id] || [];
    const registration = shipmentRegisters.length === 1 ? shipmentRegisters[0] : '';
      const supplier = shipment['supplier_id'];
      return {
        ...registration,
        ...shipment,
        supplier_id: supplier,
        tableData: { checked: shipmentIdSelected === shipment.id }
      };
    });

  // Using a already present shipment. User only as to select the shipment to
  // activate the save button. The Save only as to add the product to composition
  // no need to create shipment.
  const handleSave = () => postInsertRequest()
      .then(() => fetchRawMaterial(rawMaterial.id))
      .then(() => closeParentContainer());

  return (
    <BigDialog
      open={true}
      handleSave={shipmentIdSelected ? handleSave : null}
      saveStyle={'contained'}
      handleClose={closeParentContainer}
    >
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={closeParentContainer}
        title={
          rawMaterial.code ?
            '[ ' + rawMaterial.code + ' ] - ' + 'CAS [ ' + rawMaterial.cas + ' ] - ' + 'EC [ ' + rawMaterial.ec + ' ] - ' + rawMaterial.name +
            `  --  Crie ou selecione um fornecimento papel reach ${shipmentType}.` :
            '[ CODIGO MP VAZIO ] - ' + 'CAS [ ' + rawMaterial.cas + ' ] - ' + 'EC [ ' + rawMaterial.ec + ' ] - ' + rawMaterial.name +
            `  --  Crie ou selecione um fornecimento papel reach ${shipmentType}.`
        }
        columns={columns(user, userAccount, rawMaterial, suppliers, shipmentType)}
        data={shipments}
        onSelectionChange={(rows, difRow) => {
          if (rows.length !== 0) {
            setShipmentIdSelected(difRow.id);
          } else {
            setShipmentIdSelected(null);
          }
        }}
        options={{
          actionsCellStyle: {
            minWidth: 200,
            paddingLeft: 20
          },
          maxBodyHeight: '50vh',
          minBodyHeight: '50vh',
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          // selectionProps: rowData => {
          //   if (
          //     shipmentType !== rowData.reach_role ||
          //     (shipmentIdSelected && rowData.id !== shipmentIdSelected)
          //   ) {
          //     return { disabled: true }
          //   }
          // }
        }}
        editable={{
          /** onRowUpdate is here because the Table will appear incorrectly if without ACÇÕES column*/
          onRowUpdate: () => Promise.resolve(),

          onRowAdd: newData => {
            const sValidation = productShipmentValidator(newData, undefined);
            const srValidation = shipmentRegisterValidator(newData, undefined);
            if (sValidation.error || srValidation.error) {
              alertError([
                ...sValidation.error ? sValidation.error : [],
                ...srValidation.error ? srValidation.error : []
              ]);
              return Promise.reject();
            }

            const rawMaterialToValidate = { ... rawMaterial, code: newData.code };
            const rmValidation = rawMaterialValidator(rawMaterialToValidate, rawMaterialsData);
            if ((!rawMaterial.code || rawMaterial.code === '') && rmValidation.error) {
              alertError(rmValidation.error);
              return Promise.reject();
            }

            const raw_material_id = rawMaterial.id;
            const tempData = { ...newData, account_id: idAccount, raw_material_id };
            return createRawMatSupplier(tempData)
              .then((data) => {
                const raw_material_supplier_id = data.id;
                const tempData = { ...newData, account_id: idAccount, raw_material_supplier_id };
                return createSupplierRegister(tempData);
              })
              .then(() => {
                if (!rawMaterial.code || rawMaterial.code === '') {
                  return updateRawMaterial(rawMaterial.id, { code: newData.code });
                } else {
                  return Promise.resolve();
                }
              })
              .then(() => postInsertRequest())
              .then(() => fetchRawMaterial(rawMaterial.id))
              .then(() => closeParentContainer());
          }
        }}
      />
    </BigDialog>
  );
};

const makeMapStateToProps = () => {
  const suppliers = lookUpIdValueSelector('suppliers', ['code', 'name']);
  const mapStateToProps = (state, props) => ({
    directRegisters: directRegistersByShipment(state),
    idAccount: currentUser(state).account_id,
    rawMaterialsData: state.rawMaterials.data,
    shipmentsOf: shipmentsByRawMaterial(state),
    suppliers: suppliers(state),
    user: currentUser(state),
    // Same row, out of the scoped `/accounts/` collection. Read for its
    // `supplier_id`, which is the account's own company.
    userAccount: currentAccount(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  createRawMatSupplier: data => dispatch(actionsRawMatSuppliers.createPromise(data)),
  removeRawMatSupplier: id => dispatch(actionsRawMatSuppliers.removePromise(id)),
  updateRawMatSupplier: (id, data) => dispatch(actionsRawMatSuppliers.updatePromise(id, data)),
  createSupplierRegister: data => dispatch(actionsSupplierRegister.createPromise(data)),
  removeSupplierRegister: id => dispatch(actionsSupplierRegister.removePromise(id)),
  updateSupplierRegister: (id, data) => dispatch(actionsSupplierRegister.updatePromise(id, data)),
  fetchRawMaterial: id => dispatch(actionsRawMaterials.fetchOne(id)),
  updateRawMaterial: (id, data) => dispatch(actionsRawMaterials.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
